export default {
  GFPP: '2a3f2e13-da41-44c5-9c89-a57ad962573e',
  MOBILE_GFPP: '0da4b694-700f-4195-ad7c-3e8f3fd3df37',
  SETTINGS: '4c347b18-f387-4e6b-a2c3-0ea7758d2784',
  MANAGE_STEPS: '7d47b500-413c-497a-9b8c-a1271036bc45',
  LAYOUTS: '5ec9d027-9cec-48fe-99ea-3dea4eb1a715',
  CUSTOMIZE_DESIGN: 'c9f9aca6-1667-4c6c-949c-8e939c45db60',
  LEARN_MORE: '6d54183b-e427-4112-bd01-a84ae718c468',
}
